// extracted by mini-css-extract-plugin
export default {"container":"Co-z","brandName":"Do-z","productName":"Eo-z","productNamePdpEnhancements":"Fo-z","breakLongProductName":"Go-z"};